/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
import pieEcharts from '@/components/app/pieEcharts/index.vue';
import barEcharts from '@/components/app/barEcharts02/index.vue';
import mtdMixins from '@/pages/mixins/index.js';
export default {
    name: 'kypm',
    components: {pieEcharts, barEcharts},
    mixins:[mtdMixins],
    data() {
        return {
            crumbsList:Object.freeze([{
                name:'扣押拍卖',
                key:'kypm'
            }]),
            // 船舶拍卖
            cbpmData:[],
            // 其他拍卖
            qtpmData:[],
            // 成交标的物种类
            cjbdwzData:[],
            // 标的物拍卖阶段
            bdwpmjdData:[],
            // 船舶扣押
            cbkyData:[],
            // 其他扣押
            qtkyData:[],
            searchData:{
                tjsj: (new Date().getFullYear() - 1)
                    .toString()
            }
        };
    },
    mounted() {
        this.initYear();
        this.initKypmYlData();
        this.initKypmYlPmfxData();
    },
    methods: {
        initYear() {
            this.dealYear(5);
        },
        dealMoney(money) {
            if (money) {
                const arr1 = money.toString().split('.');
                const arr2 = arr1[0].split('').reverse();
                const arr3 = [];
                if (arr2.length > 3) {
                    for (let i = 0; i < arr2.length; i++) {
                        arr3.push(arr2[i]);
                        if (i % 3 === 2 && i !== arr2.length - 1) {
                            arr3.push(',');
                        }
                    }
                    arr1[0] = arr3.reverse().join('');
                    return arr1.join('.');
                }
                return money;
            }
        },
        // 点击拍卖跳转详情
        clickXq(item) {
            const routeUrl = this.$router.resolve({path: '/kypm/xq', query: {bh: item.bh, bdlb: item.bdlb, lx: '19'}});
            window.open(routeUrl.href, '_blank');
        },
        // 点击跳转扣押详情
        clickKyxq(item) {
            const routeUrl = this.$router.resolve({path: '/kypm/kyxq', query: {bh: item.bh, bdlb: item.bdlb, lx: '20'}});
            window.open(routeUrl.href, '_blank');
        },
        handleMore(type, code) {
            window.localStorage.setItem(type, code);
            this.$router.push({
                path: '/kypm/more',
                query: {
                    tab: type,
                    code: code
                }
            });
        },

        // 扣押拍卖预览信息拍卖分析
        initKypmYlPmfxData() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.kypm.kypmYlPmfx,
                params: {tjsj: this.searchData.tjsj}
            }).then((res) => {
                // 初始化成交标的物种类
                this.cjbdwzData = this.handleTop5(res.data.pmfxBdwVOList, 'bdlbTranslateText', 'bdwCount');
                // // 初始化标的物拍卖阶段
                this.initBdwpmjd(res.data.pmfxPmjdVOList);
            });
        },

        // 扣押拍卖预览信息
        initKypmYlData() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.kypm.kypmYl
            }).then((res) => {
                // 初始化船舶拍卖的数据
                this.initCbpm(res.data.cbpm);
                // 初始化其他拍卖的数据
                this.initQtpm(res.data.qtpm);
                this.cbkyData = res.data.cbky;
                this.qtkyData = res.data.qtky;
            });
        },
        // 初始化标的物拍卖阶段
        initBdwpmjd(data) {
            const _data = [];
            data.forEach((item) => {
                _data.push({
                    name:item.pmjdTranslateText,
                    value:item.pmjdCount
                });
            });
            this.bdwpmjdData = _data;
        },
        // 成交标的物种类
        // 处理只展示top5+其他
        handleTop5(data, name, key, conversion) {
            let copyData = [...data];
            // 需要返回的数据
            const rtData = [];
            // 其他类总数
            let pmfxBdwVOTotal = 0;
            // 需要筛选的数据(其他财产类)
            let filterData = null;
            const filteDataIndex = data.findIndex(item => item.bdlb === '255');
            if (filteDataIndex !== -1) {
                // 将筛选出来的保存
                filterData = copyData.splice(filteDataIndex, 1);
                pmfxBdwVOTotal += Number(filterData[0][key]);
            }
            // splice会改变原数组，所以当前数组已经没有其他财产类
            copyData = copyData.sort(this.compare(key));
            copyData.forEach((item, index) => {
                // 可能没有返回数据，默认为0
                if (!item[key]) {
                    item[key] = 0;
                } else if (conversion) {
                    // 四舍五入保留两位
                    item[key] = Math.round(item[key] / 10000 * 100) / 100;
                }
                // 只展示前五
                if (index < 5) {
                    rtData.push({
                        name:item[name],
                        value:item[key]
                    });
                } else {
                    // 大于五展示为其他
                    pmfxBdwVOTotal += Number(item[key]);
                }
            });
            if (pmfxBdwVOTotal) {
                if (conversion) {
                    // 四舍五入保留两位
                    pmfxBdwVOTotal = Math.round(pmfxBdwVOTotal / 10000 * 100) / 100;
                }
                rtData.push({
                    name:'其他',
                    value:pmfxBdwVOTotal
                });
            }
            return rtData;
        },
        // 排序
        compare(property) {
            return function (a, b) {
                const value1 = a[property];
                const value2 = b[property];
                return value2 - value1;
            };
        },
        // 初始化船舶拍卖的数据
        initCbpm(data) {
            data.forEach((item) => {
                item.bdwzpdz = item.bdwzpdz || '/static/image/img-zwsj.png';
            });
            // 船舶拍卖
            this.cbpmData = data;
        },
        // 初始化其他拍卖的数据
        initQtpm(data) {
            data.forEach((item) => {
                item.bdwzpdz = item.bdwzpdz || '/static/image/img-zwsj.png';
            });
            this.qtpmData = data;
        }
    }
};

